/* Info component on the Create and Callsheet form
   telling users that the Add Cast and Add Background forms are 
   seperate from the main Callsheet form */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import { useCurrentUser } from '../../../contexts/CurrentUserContext';

const InfoCall2 = () => {
  const currentUser = useCurrentUser();
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center pb-2 ${styles.Red }`} >2ND UNIT - CALLSHEEET INFO</h5>
        <hr className={`mt-2 mb-0`}/>
        <div>  
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}> Edit</span> button 
        here to open the Callsheet Add/Edit page, which contains an info tab containing the necessary instructions.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> When the Callsheet is finalised use the <span className={`${styles.Red}`}>COPY LINK</span> button 
        to copy the Callsheet page link and send it to the Crew and Cast needed for the Day, along 
        with the Stunt and Extras Coordinators, by 
        your own personal email service.
        </p>
        <p className={`pt-3 ${styles.Small} `}>
        <span className={`${styles.Red}`}>*</span> Users who are assigned to work on the 2nd Unit Callsheet need to be given 
        the <span className={`${styles.Red}`}>Admin or Superadmin Permission</span>.
        </p>
        <p className={`${styles.Small} pt-2`}>
        <span className={`${styles.Red}`}>*</span> Important! Admins and Superadmins not assigned to work on the Callsheet should not 
        create, edit or delete Callsheets.
        </p>
        </div>
        <hr className={`mt-2 mb-0`}/>
        </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoCall2